import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/cn';

function useSourceLabels() {
  const { t } = useTranslation();
  return {
    ai_generated: t('questions.ai'),
    manual: t('questions.manual'),
    imported: t('questions.imported'),
    testfit: t('questions.testfit'),
  };
}

export default function SourceBadge({ source, className }) {
  const SOURCE_LABELS = useSourceLabels();
  const label = SOURCE_LABELS[source] || source;

  return (
    <span
      className={cn(
        'inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium',
        'bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400',
        className
      )}
    >
      {label}
    </span>
  );
}
